/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ETagStatus } from "../types/ETagStatus.ts";

/**
 * @description 1 = Active | 2 = Cancelled |
 */
export const eTagStatusSchema = z
  .union([z.literal(1), z.literal(2)])
  .describe("1 = Active | 2 = Cancelled | ") as unknown as ToZod<ETagStatus>;
